import { getFileFamily } from 'jamespot-user-api';
import React, { Fragment } from 'react';

import { AlbumBackgroundVideoWrapper, AlbumImage, AlbumImageWrapper } from '../styles';
import { JRCFileVideo } from 'components/JRCFile/JRCFileVideo';
import { useImageLoader } from 'hooks/UseImageLoader';
import { JRCLoader } from 'components/JRCLoader/JRCLoader';
import { AlbumFamilyType } from '../const';
import { JRCAlbumItemFile } from '../types';

export const AlbumItem = ({ file, width, height }: { file: JRCAlbumItemFile; width: number; height: number }) => {
    const fileFamily = getFileFamily(file.mimetype);
    const size = `fitx${width * 2}`;

    if (fileFamily === AlbumFamilyType.IMAGE || fileFamily === AlbumFamilyType.GIF) {
        return (
            <AlbumImageWrapper width={width} height={height}>
                <AlbumItemImage uri={file.uri.replace(file.size, size)} />
            </AlbumImageWrapper>
        );
    }

    if (fileFamily === AlbumFamilyType.VIDEO) {
        return (
            <AlbumBackgroundVideoWrapper width={width} height={height}>
                <JRCFileVideo uri={file.uri} mimetype={file.mimetype} />
            </AlbumBackgroundVideoWrapper>
        );
    }

    return <Fragment />;
};

export const AlbumItemImage = ({ uri }: { uri: string }) => {
    const { loading } = useImageLoader(uri);

    if (loading) return <JRCLoader />;

    return <AlbumImage loading="lazy" src={uri} />;
};
